import { useState, useEffect, useRef } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./Sidebar";
import DashboardHome from "./DashboardHome";
// import Users from "./Users";
import Rooms from "../user-portal/pages/rooms/Rooms";
import AddNewRoom from "../user-portal/pages/rooms/AddNewRoom";
// import Storage from "./Storage";
import Recordings from "../user-portal/pages/recordings/Recordings";
import Profile from "../../components/auth-user/Profile";
import FolderList from "../user-portal/folders/FolderList";
import FileView from "../user-portal/folders/FileView";
import WidgetPanel from "./pages/elemets/widget/WidgetPanel";
import { NavLink } from "react-router-dom";
import ElementView from "./folders/ElementView";
import CommonElementView from "./folders/CommonElementView";
import EditRoom from "./pages/rooms/EditRoom";
import EditScheduleMeeting from "./pages/rooms/EditScheduleMeeting";
import { ToastContainer } from "react-toastify";
import EditCtaTemplate from "./pages/elemets/widget/EditCtaTemplate";
import EditWebsite from "./pages/elemets/widget/EditWebsite";
import EditPrompter from "./pages/elemets/widget/EditPrompter";
import { useSiteContext } from "../../context/SiteContext";
// import AINotetaker from "./AINotetaker";
import WebinarScheduleForm from "./forms/WebinarScheduleForm";
import EditWebinarScheduleForm from "./forms/EditWebinarScheduleForm";
import AINotetaker from "./AINotetaker";
import Sessions from "./pages/Sessions";
import CreatePolls from "./polls/CreatePolls";
import PollList from "./polls/PollList";
import EditPoll from "./polls/EditPoll";

const UserPortal = () => {
  const { user } = useSiteContext();
  const [sidebarOpen, setSidebarOpen] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= 768 : true
  );
  // const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Ensure sidebar is opened by default on desktop and when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined" && window.innerWidth >= 768) {
        setSidebarOpen(true);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const handleProfileClick = () => {
  //   navigate("/profile");
  // };

  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRefDesktop = useRef(null);
  const userMenuRefMobile = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      const clickedInsideDesktop =
        userMenuRefDesktop.current &&
        userMenuRefDesktop.current.contains(e.target);
      const clickedInsideMobile =
        userMenuRefMobile.current &&
        userMenuRefMobile.current.contains(e.target);
      if (!clickedInsideDesktop && !clickedInsideMobile) setShowUserMenu(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const headerLogout = () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("meetingRole");
      localStorage.removeItem("meetingId");
      localStorage.removeItem("meetingToken");
      localStorage.removeItem("meetingMicOn");
      localStorage.removeItem("meetingWebcamOn");
    } catch (_) {}
    window.location.href = "/login";
  };

  return (
    <div className="flex h-screen w-full overflow-x-hidden portal-background">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Mobile backdrop when sidebar open */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/40 md:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Main Content */}
      <div
        className={`flex-1 flex flex-col transition-all duration-300 ml-0 ${
          sidebarOpen ? "md:ml-56" : "md:ml-16"
        }`}
      >
        <div className="w-full z-10">
          {/* Header (fixed, full-width, overlaps sidebar) */}
          <header className="fixed top-0 left-0 right-0 z-40 bg-black h-16">
            {/* Desktop logo pinned to far left, independent of centered content */}
            <img
              src="/r-link-fav.svg"
              alt="R-Link"
              className="hidden md:block absolute left-4 top-1/2 -translate-y-1/2 h-8 w-auto"
            />
            {/* Desktop profile dropdown pinned to far right */}
            <div
              ref={userMenuRefDesktop}
              className="hidden md:flex items-center absolute right-4 top-1/2 -translate-y-1/2"
            >
              <div className="relative">
                <button onClick={() => setShowUserMenu((s) => !s)} className="">
                  <img
                    src={user?.logo ? user.logo : "/icons/profile.svg"}
                    alt="Profile1"
                    className="h-8 w-8 rounded-full object-cover"
                  />
                </button>
                {showUserMenu && (
                  <div className="absolute right-0 top-full mt-2 w-44 rounded-md shadow-lg py-1 z-[100] bg-white">
                    <NavLink
                      to="/dashboard/profile"
                      className="block px-3 py-2 text-sm text-black hover:bg-gray-300"
                      onClick={() => setShowUserMenu(false)}
                    >
                      Profile
                    </NavLink>
                    <button
                      onClick={headerLogout}
                      className="w-full text-left px-3 py-2 text-sm  text-black hover:bg-gray-300"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full max-w-6xl mx-auto h-full flex items-center justify-between px-4 md:px-6 relative">
              <div className="flex items-center">
                <button
                  onClick={toggleSidebar}
                  className="p-2 rounded-md text-white hover:text-white  md:hidden"
                >
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
                {/* Mobile logo shown next to hamburger */}
                <img
                  src="/r-link-fav.svg"
                  alt="R-Link"
                  className="md:hidden h-8 w-auto ml-2"
                />
              </div>
              {/* Mobile profile button inside centered container */}
              <div className="flex md:hidden justify-end px-2 rounded-lg">
                <div ref={userMenuRefMobile} className="relative">
                  <button
                    onClick={() => setShowUserMenu((s) => !s)}
                    className="w-8 h-8 rounded-full flex items-center justify-center transition-colors"
                  >
                  {user?.logo ? <img
                      src={user?.logo}
                      alt="Profile1"
                      className="h-full w-full rounded-full object-cover"
                    /> : <img
                      src="/icons/profile.svg"
                      alt="Profile1"
                      className="h-6 w-6"
                    />}
                  </button>
                  {showUserMenu && (
                    <div className="absolute right-0 mt-2 w-40 rounded-md shadow-lg py-1 z-50 bg-white">
                      <NavLink
                        to="/dashboard/profile"
                        className="block px-3 py-2 text-sm text-black hover:bg-gray-100"
                      >
                        Profile
                      </NavLink>
                      <button
                        onClick={headerLogout}
                        className="w-full text-left px-3 py-2 text-sm text-black hover:bg-gray-100"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Desktop user info and menu */}
          </header>

          {/* Main Content Area */}
          <main className="flex-1 overflow-y-auto overflow-x-hidden  md:p-6 pt-16 md:pt-20">
            <ToastContainer />
            <div className="w-full max-w-7xl mx-auto">
              <Routes>
                <Route path="/" element={<DashboardHome />} />
                <Route path="/rooms" element={<Rooms />} />
                <Route path="/add-new-room" element={<AddNewRoom />} />
                <Route path="/edit-room/:roomId" element={<EditRoom />} />
                <Route
                  path="/edit-schedule-meeting/:roomId"
                  element={<EditScheduleMeeting />}
                />
                <Route
                  path="/edit-webinar/:roomId"
                  element={<EditWebinarScheduleForm />}
                />
                <Route path="/recordings" element={<Recordings />} />

                <Route path="/profile" element={<Profile />} />

                <Route path="/folders" element={<FolderList />} />
                <Route
                  path="/fileview/:folderId/:category"
                  element={<FileView />}
                />

                <Route
                  path="/folders/element/:folderId"
                  element={<ElementView />}
                />

                <Route
                  path="/common-folders/element/:folderId"
                  element={<CommonElementView />}
                />

                <Route path="/elemets/:folderId" element={<WidgetPanel />} />

                <Route
                  path="/elemets/edit-cta/:folderId"
                  element={<EditCtaTemplate />}
                />

                <Route
                  path="/elements/edit-website/:folderId"
                  element={<EditWebsite />}
                />

                <Route
                  path="/elemets/edit-prompter/:folderId"
                  element={<EditPrompter />}
                />

                <Route path="/polls" element={<PollList />} />
                <Route path="/create-poll" element={<CreatePolls />} />

                <Route
                  path="/ai-notetaker/:sessionId"
                  element={<AINotetaker />}
                />
                <Route path="/sessions" element={<Sessions />} />

                <Route path="/edit-poll/:pollId" element={<EditPoll />} />

                <Route
                  path="/webiner-detail"
                  element={<WebinarScheduleForm />}
                />
                {/* <Route path="/settings" element={<Settings />} /> */}
                {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
              </Routes>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default UserPortal;
